export const cityNames = [
  { en: 'Taipei', zh: '臺北市' },
  { en: 'NewTaipei', zh: '新北市' },
  { en: 'Taoyuan', zh: '桃園市' },
  { en: 'Taichung', zh: '臺中市' },
  { en: 'Tainan', zh: '臺南市' },
  { en: 'Kaohsiung', zh: '高雄市' },
  { en: 'Keelung', zh: '基隆市' },
  { en: 'Hsinchu', zh: '新竹市' },
  { en: 'HsinchuCounty', zh: '新竹縣' },
  { en: 'MiaoliCounty', zh: '苗栗縣' },
  { en: 'ChanghuaCounty', zh: '彰化縣' },
  { en: 'NantouCounty', zh: '南投縣' },
  { en: 'YunlinCounty', zh: '雲林縣' },
  { en: 'ChiayiCounty', zh: '嘉義縣' },
  { en: 'Chiayi', zh: '嘉義市' },
  { en: 'PingtungCounty', zh: '屏東縣' },
  { en: 'YilanCounty', zh: '宜蘭縣' },
  { en: 'HualienCounty', zh: '花蓮縣' },
  { en: 'TaitungCounty', zh: '台東縣' },
  { en: 'KinmenCounty', zh: '金門縣' },
  { en: 'PenghuCounty', zh: '澎湖縣' },
  { en: 'LienchiangCounty', zh: '連江縣' }
]
